/**
 * Custom error class that preserves the raw API response body
 * for debugging purposes.
 */
export class ApiError extends Error {
  public readonly response: unknown;
  public readonly status?: number;
  public readonly method?: string;
  public readonly endpoint?: string;

  constructor(
    message: string,
    response: unknown,
    options?: { status?: number; method?: string; endpoint?: string }
  ) {
    super(message);
    this.name = "ApiError";
    this.response = response;
    this.status = options?.status;
    this.method = options?.method;
    this.endpoint = options?.endpoint;
  }
}
